import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentOutline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Outline", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M78.62,33.3,60.07,14.64A2.13,2.13,0,0,0,58.55,14H22.91a2.17,2.17,0,0,0-2.16,2.17V83.83A2.17,2.17,0,0,0,22.91,86H77.09a2.17,2.17,0,0,0,2.16-2.17v-49A2.2,2.2,0,0,0,78.62,33.3ZM61,21.41,72.14,32.66H61ZM25.06,81.66V18.34H56.39V37H74.94V81.66Z" }));
const ForwardRef = forwardRef(SvgDocumentOutline);
export { ForwardRef as ReactComponent };
